import React from "react";
import { Box, Stack, Text, useColorModeValue } from "@chakra-ui/react";


const WamEmptyState = ({ title, description, action = null }) => {
  const bg = useColorModeValue("blackAlpha.50", "whiteAlpha.100");

  return (
    <Box
      borderWidth="1px"
      borderStyle="dashed"
      borderColor="wam.border"
      borderRadius="26px"
      px={5}
      py={8}
      bg={bg}
      textAlign="center"
    >
      <Stack spacing={3} align="center">
        <Text fontWeight="700" color="wam.text.primary">
          {title}
        </Text>
        {description ? (
          <Text maxW="30rem" fontSize="sm" color="wam.text.secondary">
            {description}
          </Text>
        ) : null}
        {action}
      </Stack>
    </Box>
  );
};


export default WamEmptyState;
